/**
 * Generates a unique key for troubleshooting list items
 * @param tip - The troubleshooting tip text
 * @param index - The array index for uniqueness
 * @returns A unique key string
 */
export const generateTipKey = (tip: string, index: number): string => {
  const sanitizedTip = tip.slice(0, 15).replace(/\s+/g, "-").toLowerCase();
  return `troubleshooting-tip-${sanitizedTip}-${index}`;
};
